// 应用管理
const applied = {
  'applied_应用管理': { cn: '应用管理', en: 'Application Manager', kr: '' },
  'applied_应用管理操作日志': {
    cn: '应用管理操作日志',
    en: 'Application management operation log',
    kr: ''
  },
  'applied_应用名称查询': { cn: '请输入应用名称查询', en: 'Application Manager name query', kr: '' },
  'applied_应用名称': { cn: '应用名称', en: 'App title' },
  'applied_app_key': { cn: 'App key', en: 'App key' },
  'applied_sercret_key': { cn: 'Secret key', en: 'Secret key' },
  'applied_应用状态': { cn: '应用状态', en: 'Application state' },
  'applied_创建时间': { cn: '创建时间', en: 'Creation time' },
  'applied_打回备注': { cn: '打回备注', en: 'Back to note' },
  'applied_应用类型': { cn: '应用类型', en: 'The application type' },
  'applied_应用简介': { cn: '应用简介', en: 'Application profile:' },
  'applied_授权状态': { cn: '授权状态', en: 'Authorization status' },
  'applied_操作': { cn: '操作', en: 'Operation' },
  'applied_个': { cn: '个', en: '' },
  'applied_我的应用': { cn: '我的应用', en: 'My application' },
  'applied_第三方应用': { cn: '第三方应用', en: 'Third party applications' },
  'applied_服务商应用': { cn: '服务商应用', en: 'Service provider application' },
  'applied_作废': {
    cn: '作废',
    en: 'invalid'
  },
  'applied_应用': { cn: '应用', en: 'apply' },
  'applied_请勾选接口': { cn: '请勾选接口！', en: 'apply' },
  'applied_请选择应用类型': { cn: '请选择应用类型', en: 'Please select application type' },
  'applied_请输入应用简介': { cn: '请输入应用简介', en: 'Please input the application profile' },
  'applied_请输入应用名称': { cn: '请输入应用名称', en: 'Please input application name' },
  'applied_请输入IP白名单': { cn: '请输入IP白名单', en: 'Please input IP white list' },
  'applied_自有应用默认获取当前账号在易仓的相关授权信息，请勾选确认': {
    cn: '自有应用默认获取当前账号在易仓科技的相关授权信息，请勾选确认',
    en: 'By default, the self owned app can obtain the relevant authorization information of the current account in ECCANG. Please check confirm'
  },
  'applied_请勾选自有应用请默认获取当前账号在易仓的相关授权信息': {
    cn: '自有应用默认获取当前账号在易仓科技的相关授权信息，请勾选确认',
    en: 'Your own application acquies the relevant authorization information of your current account in Yicang by default. Please check it for confirmation'
  },
  'applied_重制密钥': { cn: '重制密钥', en: 'Packages lower than the current package level are not supported for purchase. If you need help, contact your sales manager for processing' },
  'applied_应用配置': { cn: '应用配置', en: 'Application' },
  'applied_btn_package_quantity_order查看接口授权': { cn: '查看接口授权情况', en: 'View the interface authorization' },
  'applied_btn_已授权': { cn: '已授权', en: 'Empowered' },
  'applied_btn_未授权': { cn: '未授权', en: 'Unauthorized' },
  'applied_btn_是否': { cn: '是否{0}？', en: 'Is it {0} invalid?' },
  'applied_btn_package_line重置秘钥': { cn: '重置秘钥', en: 'Reset the secret key' },
  'applied_btn_package_line已打回': { cn: '已打回', en: 'Has been back' },
  'applied_btn_package_line修改待审核': { cn: '修改待审核', en: 'Modification to be reviewed' },
  'applied_btn_package_line已作废': { cn: '已作废', en: 'Invalid' },
  'applied_btn_package_line是否重置秘钥？': { cn: '是否重置秘钥？', en: 'Do you want to reset the secret key?' },
  // 'buyServe_btn_package_Images图片空间': { cn: '图片空间', en: 'Image space' },
  'applied_btn_IP白名单': { cn: 'IP白名单：', en: 'IP white list:' },
  'applied_btn_接口申请': { cn: '接口申请', en: 'Text Translation' },
  'applied_btn_输入IP地址多个IP地址需用分号隔开': {
    cn: '输入IP地址多个IP地址需用分号隔开',
    en: 'Enter IP addresses. Multiple IP addresses should be separated by semicolons'
  },
  'applied_btn_输入IP地址多个IP地址需用分号隔开_举例': {
    cn: '输入IP地址多个IP地址需用分号隔开，举例：192.268.2.1;127.0.0.1开放给所有用户的时候，配置IP 为0.0.0.0',
    en: 'Enter IP addresses. Multiple IP addresses should be separated by semicolons. For example: 192.268.2.1; when 127.0.0.1 is open to all users, configure IP as 0.0.0.0'
  },
  'applied_详细描述您的应用，用于审核及展示，最多不超过500个字符': {
    cn: '详细描述您的应用，用于审核及展示，最多不超过500个字符',
    en: 'Detailed description of your application, for audit and display, up to 500 characters'
  },
  'applied_自有应用默认获取当前账号在易仓的相关授权信息': {
    cn: '自有应用默认获取当前账号在易仓科技的相关授权信息',
    en: 'Self owned applications obtain the relevant authorization information of the current account in e-warehouse by default'
  },
  'applied_当前无接口获得授权': { cn: '当前无接口获得授权', en: 'No interfaces are currently authorized' },
  'applied_您可以联系对应易仓商户在用户中心中为您授权': {
    cn: '您可以联系对应易仓科技商户在用户中心中为您授权',
    en: 'You can contact the corresponding e-warehouse merchant to authorize for you in the user center'
  },
  'applied_服务ID': { cn: '服务ID：', en: 'service ID:' },
  'buyServe_btn_package_stores授权店铺': {
    cn: '输入IP地址多个IP地址需要用分号隔开，举例：192.268.2.1；127.0.0.1开放给所有用户的时候，配置IP为0.0.0.0',
    en: 'Number of distribution stores'
  },
  'applied_应用名称不能超过50个字符': { cn: '应用名称不能超过50个字符', en: 'Number of products distributed' },
  'buyServe_btn_package_price': {
    cn: '详情描述您的应用，用户审核及展示，最多不超过500个字符',
    en: 'Package price'
  },
  'buyServe_btn_package_contrast': { cn: '套餐对比', en: 'Contrast' },
  'service_buyServe_btn_package_more': { cn: '该版本更多套餐价格请致电0755-86528003', en: 'For more information, please call 0755-86528003' },
  'buyServe_btn_buy_title_smart智能硬件': { cn: '智能硬件', en: 'Intelligent hardware' },
  'buyServe_btn_buy_select_platform': { cn: '选择平台', en: 'Select platform' },
  'buyServe_btn_buy_select_platform_package': { cn: '套餐', en: 'package' },
  'buyServe_btn_buy_select_platform_supports': { cn: '当前{0}支持使用', en: 'Currently {0} is supported' },
  'buyServe_btn_buy_select_platform_supports1': { cn: '请您选择需要开通的平台', en: 'Please select the platform you want to open' },
  'buyServe_btn_buy_select_platform_supports2': { cn: '平台开通后', en: 'after the platform is opened' },
  'buyServe_btn_buy_select_platform_supports3': { cn: '不能进行更改', en: 'no changes can be made' },
  'buyServe_btn_buy_select_platform_supports4': { cn: '至少选择1个平台，', en: 'Choose at least one platform' },
  'buyServe_btn_buy_select_platform_supports5': { cn: '剩余未选平台后续可在服务有效期内至服务管理中选择', en: 'The remaining unselected platforms can be selected from the service management during the service validity period' },
  'buyServe_btn_buy_select_platform_supports6': { cn: '个平台可选', en: 'after the platform is opened, it will' },
  'buyServe_btn_buy_select_platform_supports7': { cn: '平台开通后将', en: 'cannot be changed after the platform is opened' },
  'buyServe_btn_buy_select_platform_supports8': { cn: '不能进行更改', en: 'cannot change' },
  'buyServe_btn_buy_select_platform_supports9': { cn: '当前套餐仅支持购买{0}个平台', en: 'The current package only supports the purchase of {0} platforms' },
  'buyServe_btn_buy_select_platform_tips_least_one': { cn: '至少选择一个平台', en: 'Select at least one platform' },
  'buyServe_btn_buy_select_platform_packages_included_not_exceed': { cn: '选择的平台数量不能多于套餐包含数量', en: 'The number of platforms you choose should not exceed the number of packages included' },
  'buyServe_btn_buy_select_platform__packages_included_not_less': { cn: '选择的平台数量不能少于套餐包含数量', en: 'The number of platforms selected should not be less than the number of packages included' }
}

export default {
  ...applied
}
